<template>
  <div class="content">
    <img class="bg" :src="imageUrl" />
    <img
      class="btn"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e2f4d3908c4a3c3cc83cb4855138d2f8.png"
      @click="bindConsult"
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      imageUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/54fc9a9aa384ff29bb3d9f192b8ab8ab.png', //默认展示的图
      url: '/miniProgram?userName=gh_0d804ee2c21b&path=pages%2Fimage-page%2Findex%3Furl%3Dhttps%253A%252F%252Fbtw-common-data.betterwestar.com%252Fbtw-admin%252Fadmin-common-data%252F2025-04%252Feca65c45a19cc78d25e4c456dc0a4562_wh%253D396_396.png'
    }
  },
  created() {
    /*  let query = this.$route.query;
        let { imageUrl, url, title } = query;
        this.imageUrl = imageUrl ? decodeURIComponent(imageUrl) : this.imageUrl;
        this.url = url ? decodeURIComponent(url) : this.url;
        if (title) {
            document.title = title;
        } */
  },
  methods: {
    bindConsult() {
      this.$betterwe.jumpRoute(this.url)
      // this.$betterwe.jumpUrlSchema(this.url);
    }
  }
}
</script>
<style scoped lang="scss">
.content {
  min-height: 100vh;
  position: relative;
}

.btn {
  width: 100%;
  position: fixed;
  left: 50%;
  bottom: 0px;
  transform: translate(-50%, 0%);
  z-index: 99;
}

.bg {
  width: 100%;
}

.not-image {
  margin-top: 200px;
  color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
</style>
